import styled from 'styled-components';
import ribbon from 'assets/offer/ribbon.png';
import check from 'assets/offer/check.png';

export const VipCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #fff9ef;
  border-radius: 20px;
  overflow: hidden;
  min-width: 500px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-bottom: 7px solid #e8d4c3;
  @media (max-width: 1015px) {
    min-width: 400px;
  }
  @media (max-width: 560px) {
    min-width: 320px;
  }
`;

export const HeaderImage = styled.div`
  width: 100%;
  height: 190px;
  background-image: url(${props => props.$bgImage});
  background-size: cover;
  background-position: center;
  position: relative;
`;

export const VipRibbon = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(${ribbon}) no-repeat;
  background-size: contain;
  width: 75px;
  height: 56px;
  top: -2px;
  left: -2px;
`;

export const VipRibbonText = styled.span`
  color: #ffffff;
  font-weight: 700;
  margin-right: 0.3rem;
  margin-bottom: 0.2rem;
  font-size: 1.2em;
`;

export const TimerTag = styled.div`
  position: absolute;
  top: 50px;
  // left: 10px;
  background-color: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  z-index: 2;
  letter-spacing: 0.5px;
`;

export const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  color: #1f1f1f;
  gap: 0.5rem;
  padding: 1rem;
  flex: 1;
`;

export const Price = styled.div`
  text-decoration: line-through red;
  text-decoration-thickness: 0.2rem;
  -webkit-text-decoration: line-through red;
  -webkit-text-decoration-thickness: 0.2rem;
  font-size: 1.3em;
  font-weight: 800;
`;

export const CoinsDisplay = styled.div`
  font-size: 20px;
  font-weight: 900;
  color: #333;
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 5px;
`;

export const InputField = styled.input`
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #dcdcdc;
  font-size: 14px;
  color: #333;
  outline: none;
  background-color: #fff;
  font-family: inherit;
  &::placeholder {
    color: #ccc;
  }

  &:focus {
    border-color: #aaa;
  }
`;

export const ConfirmBtn = styled.button`
  width: 100%;
  padding: 10px 0;
  background: linear-gradient(180deg, #8ed91c 0%, #4ca908 100%);
  border: none;
  border-radius: 10px;
  color: white;
  font-size: 18px;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 4px 0 #3a8205;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  margin-top: 5px;

  &:active {
    transform: translateY(2px);
    box-shadow: 0 2px 0 #3a8205;
  }

  &:disabled {
    filter: grayscale(100%);
    cursor: not-allowed;
  }
`;

// Helper for debug mode
export const DebugId = styled.div`
  position: absolute;
  color: #ffffff;
  right: 25px;
  top: 2px;
  font-weight: 700;
  font-size: 0.9em;
  text-shadow: 0px 1px 1px black;
`;

export const ErrorText = styled.span`
  font-weight: 600;
  color: #999;
  font-size: 0.8rem;
`;

export const TimerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  font-weight: 800;
  padding-bottom: 2rem;
`;

export const Timer = styled.div`
  color: #ffffff;
  background-color: #f0255d;
  padding: 0.5rem 3rem;
  border-radius: 5rem;
  font-weight: 800;
  letter-spacing: 0.1rem;
`;

export const GiftSelectedContainer = styled.div`
  background-color: #faefde;
  box-shadow: inset 0 5px 6px 2px #f1e2cf;
  border-radius: 0.5rem;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 1rem 0.1rem;
`;

export const GiftSelectedText = styled.div`
  font-size: 18px;
  font-weight: 800;
  color: #333;
  margin: 15px;
  text-align: center;
`;

export const GiftSelectedIcon = styled.img.attrs(() => ({
  src: check,
}))`
  width: 40px;
  height: 40px;
`;
